/**
 * Long-text limit counted the way Word counts characters (spaces included,
 * line breaks not counted) — the CQDD writes these texts in Word.
 *
 * Mirrors `expert/text_length.py`, which is the rule: the server refuses what
 * gets past this counter.
 */

export const LONG_TEXT_LIMIT = 1000;

/**
 * `ExpertProfile.affiliations` is a 300-column `CharField`, not one of the
 * Word-counted texts — a plain column limit, counted the way the browser
 * counts, as the Django widget's own `maxlength` counts it.
 */
export const AFFILIATIONS_LIMIT = 300;

/**
 * `ExpertProfile.head_office_address` and `ExpertBusinessLocation.address`
 * are both 255-column `CharField`s, capped the way the Django inputs' own
 * `maxlength` caps them.
 */
export const ADDRESS_LIMIT = 255;

export function wordLength(text: string | null | undefined): number {
  return (text ?? "").replace(/[\r\n]/g, "").length;
}
